
import {
  IonApp,
  IonList,
  IonRouterOutlet,
  IonIcon,
  IonSplitPane,
  IonLabel,
  IonItem,
  IonContent,
  IonMenu,
  IonToolbar,
  modalController,
  IonTitle,
  IonNote,
  IonHeader,
  IonButton,
  IonButtons,
  IonImg,
  IonSearchbar,
  IonGrid,
  IonCol,
  IonRow,
  alertController,
} from "@ionic/vue";
import { defineComponent, ref, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { logOut } from "ionicons/icons";
import { LoginUtility } from "./views/LoginUtility/LoginUtility";
import { useApplicationStore } from "./stores/ApplicationStore";
import LoginPage from "./views/Login/LoginPage.vue";

export default defineComponent({
  name: "AppPage",
  components: {
    IonApp,
    IonContent,
    IonList,
    IonToolbar,
    IonRouterOutlet,
    IonSplitPane,
    IonIcon,
    IonLabel,
    IonItem,
    IonMenu,
    IonHeader,
    IonTitle,
    IonNote,
    IonButton,
    IonButtons,
    IonImg,
    IonSearchbar,
    IonGrid,
    IonCol,
    IonRow,
  },

  data() {
    return {
      Menu: [] as any,
      searchQuery: "",
    };
  },

  computed: {
    filteredMenu() {
      if (!this.searchQuery) {
        return this.Menu;
      }
      const query = this.searchQuery.toLowerCase();
      return this.Menu.filter((item: any) => {
        const label = this.$t(item?.label).toLowerCase();
        return label.includes(query);
      });
    },
  },

  setup() {
    const appStore = useApplicationStore();
    const router = useRouter();
    const instance: any = getCurrentInstance();
    const app_title = instance.appContext.config.globalProperties.$APP_TITLE;

    const LOGO_TEXT = instance.appContext.config.globalProperties.$LOGO_TEXT || "";

    const openLogin = async () => {
      const login = new LoginUtility();
      router.push("/mainhome");
      login.LogOut();

      const modal = await modalController.create({
        component: LoginPage,
        cssClass: "fullscreen",
        canDismiss: canDismiss,
      });

      async function canDismiss() {
        const appStore = useApplicationStore();
        return appStore.$APP_READY;
      }

      await modal.present();
    };

    return {
      router,
      logOut,
      openLogin,
      app_title,
      LOGO_TEXT,
      appStore,
    };
  },

  methods: {
    navigate(route: string) {
      const menu = document.querySelector("ion-menu");
      menu?.close();
      if (route) {
        this.router.push(route);
      }
    },
    getMenuItem() {
      fetch("/Menu.json")
        .then((response) => response.json())
        .then((menu) => {
          this.Menu = menu.Menu;
        })
        .catch((error) => {
          console.error("Error fetching menu items:", error);
        });
    },
    filterMenuItems() {
      // This method is intentionally left blank as the filtering is handled in the computed property
    },
    async confirmLogout() {
      console.log("Logout clicked"); // Debug log
      const alert = await alertController.create({
        header: "Confirm Logout",
        message: "Are you sure you want to log out?",
        buttons: [
          {
            text: "Cancel",
            role: "cancel",
            handler: () => {
              console.log("Logout cancelled"); // Debug log
            },
          },
          {
            text: "Logout",
            handler: () => {
              console.log("Logout confirmed"); // Debug log
              this.openLogin();
            },
          },
        ],
      });
      await alert.present();
    },
  },

  mounted() {
    document.title = this.app_title;
    this.getMenuItem();
  },
});
